import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const MenuIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-menu-icon': true,
      [className]: className,
    })}
    name={IconNames.MENU_LINES}
    size={size}
    {...rest}
  />
);

MenuIcon.propTypes = {
  ...iconPropTypes,
};

MenuIcon.defaultProps = {
  ...iconDefaultProps,
};


export default MenuIcon;
